var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.834 241.709C305.918 239.871 308.244 238.402 310.219 236.406C332.937 213.5 345.25 183.094 344.937 150.813C344.281 85.312 290.438 32 224.938 32H24C10.75 32 0 42.75 0 56S10.75 80 24 80H48V432H24C10.75 432 0 442.75 0 456S10.75 480 24 480H240C310.594 480 368 422.594 368 352C368 304.758 342 263.887 303.834 241.709ZM224.938 80C264.25 80 296.531 112 296.938 151.312C297.125 170.656 289.719 188.875 276.094 202.656C262.469 216.406 244.312 224 224.938 224H96V80H224.938ZM240 432H96V272H240C284.125 272 320 307.875 320 352S284.125 432 240 432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.98eedc8f10d726d9a4dd4c7a92e1c6ea.svg";
export { ForwardRef as ReactComponent };